<app-family-landing>
  <div class="form" *ngIf="!isMfaTokenVisible">
    <app-family-login-form
      [loginFailed]="loginFailed"
      [triesCount]="loginFailCount"
      (submitted)="onSubmit($event)"
      [isBusy]="isBusy"
    ></app-family-login-form>
  </div>
  <div class="form" *ngIf="isMfaTokenVisible">
    <app-login-mfa
      [loginFailed]="loginFailed"
      [triesCount]="loginFailCount"
      [isBusy]="isBusy"
      [mfaToken]="mfaToken"
      (submitted)="onSubmitMfa($event)"
    ></app-login-mfa>
  </div>
</app-family-landing>
